module.exports = __webpack_public_path__ + "static/img/getrule.74efd96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/getrule.png
// module id = 9cmC
// module chunks = 1